import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { BroadcastOneTime } from 'entities/Broadcast'

export class RowBroadcastOneTime extends RowBase<BroadcastOneTime> {
  constructor(origin: BroadcastOneTime) {
    super(origin)

    makeObservableRowBase(this)
  }
  init = () => this.origin.init()

  get name() {
    return this.origin.name
  }

  get type() {
    return this.origin.type
  }

  get user() {
    return this.origin.user
  }

  get status() {
    return this.origin.status
  }

  get isInvalid() {
    return this.origin.isInvalid
  }
}
